import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export function createModuleConfig(baseUrl: string): OAuthModuleConfig {
  return { resourceServer: { sendAccessToken: true, allowedUrls: [baseUrl] } };
}
